export default "__VITE_ASSET__fbc6a19a__"